export default __webpack_public_path__ + "static/media/user_logo.ca20845f.svg";